import { WoundCareConstants } from '../store/woundCare.constants'

// TODO: Add this line to src\features\validation\schemas\index.ts
// export { woundCareSchemas } from '../../woundCare/validation/woundCare.schema'

export const woundCareSchemas = [
  {
    inputKey: WoundCareConstants.SET_ACTIONS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_ACTIONS: {
        type: 'number',
        // ToDo: confirm Pattern/ Min/ Max is set correctly
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_ACTIONS'],
  },
  {
    inputKey: WoundCareConstants.SET_SITE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SITE: {
        type: 'number',
        // ToDo: confirm Pattern/ Min/ Max is set correctly
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_SITE'],
  },
  {
    inputKey: WoundCareConstants.SET_SIZE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SIZE: {
        type: 'number',
        // ToDo: confirm Pattern/ Min/ Max is set correctly
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_SIZE'],
  },
  {
    inputKey: WoundCareConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: WoundCareConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const woundCareSecondsSchemas = [
  {
    inputKey: WoundCareConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
